import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import Footer from "./Footer";
import Header from "./Header";
import HireDevelopersImg from "./assets/img/HireDevelopers.png";
import { Modal } from "react-bootstrap";
const HireDevelopers = () => {
  const [lgShow, setLgShow] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    company: "",
    email: "",
    projectDescription: "",
  });

  const [activeIndex, setActiveIndex] = useState(0);

  const words = ["Growth", "Success", "Impact"]; // example words

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % words.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);

    try {
      const response = await axios.post(
        "https://p506xqqura.execute-api.ap-south-1.amazonaws.com/contact",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Form submitted successfully:", response.data);

      setLgShow(false);

      setFormData({
        name: "",
        designation: "",
        company: "",
        email: "",
        projectDescription: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  return (
    <>
      <Helmet>
        <title>
          Hummingtec: Pioneering Technology Solutions in Healthcare and Beyond
        </title>
        <meta
          name="description"
          content="Discover Hummingtec's journey from a startup in 2016 to a leader in healthcare technology and software solutions. Explore our vision for a future where technology and human ingenuity merge to drive innovation and efficiency."
        />
        <meta
          name="keywords"
          content="Hummingtec, healthcare technology, software development, Pillnurse, digital transformation, AI and ML, blockchain, IoT, CRM solutions, Zoho, Salesforce, medication adherence, technology innovation"
        />
        <link
          rel="canonical"
          href="https://www.hummingtec.com/HireDevelopers"
        />
      </Helmet>
      <Header></Header>
      <div className="mainContent">
        <section className="hireDev-hero">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="leftWrap">
                  <span className="breadcrumb-label">
                    ▸ NEXT GENERATION FRONTEND SOLUTIONS
                  </span>
                  <h1>
                    Hire React &amp; <br />
                    <span>Next.js Developers</span>
                  </h1>
                  <p>
                    Frontend Development Partner for US Startups &amp; SaaS
                    Companies. We architect high-performance digital experiences
                    that scale with your vision.
                  </p>
                  <ul>
                    <li>
                      {" "}
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                          fill="#451464"
                        />
                      </svg>
                      Dedicated React Developers
                    </li>
                    <li>
                      {" "}
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                          fill="#451464"
                        />
                      </svg>
                      Startup & SaaS Product Experience
                    </li>
                    <li>
                      {" "}
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                          fill="#451464"
                        />
                      </svg>
                      Scalable Development Teams
                    </li>
                    <li>
                      {" "}
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                          fill="#451464"
                        />
                      </svg>
                      Flexible Engagement Models
                    </li>
                  </ul>
                  <div className="heroActions">
                    <button
                      onClick={() => {
                        setFormData((prev) => ({ ...prev, type: "hire" }));
                        setLgShow(true);
                      }}
                      className="btnPrimary"
                    >
                      Start Your Project Today
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="heroImgWrap">
                  <div className="heroImgPlaceholder">
                    <img src={HireDevelopersImg} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="hireDev-trusted">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h3>
                  Trusted Frontend Development Company for Modern Businesses
                </h3>
                <p>
                  At <strong>Hummingtec</strong>, we help businesses build
                  scalable digital products using modern frontend technologies.
                </p>
                <p>
                  Our team collaborates with startups and companies across the
                  <strong>United States</strong> to deliver reliable frontend
                  development solutions that improve{" "}
                  <strong>
                    user experience, application performance, and scalability.
                  </strong>
                </p>
                <p>
                  From{" "}
                  <strong>startup MVPs to enterprise-level platforms,</strong>{" "}
                  we build frontend systems designed for performance, stability,
                  and long-term growth.
                </p>
                <p>
                  Our developers focus on writing{" "}
                  <strong>clean, maintainable code</strong> and building{" "}
                  <strong>intuitive user interfaces</strong> that improve
                  customer engagement and usability.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="hireDev-strategic">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h2>Frontend Development Services</h2>
                <p className="introText">
                  We don't just build UIs—we build intelligent systems that
                  empower your business to move faster and provide better user
                  experiences.
                </p>
              </div>
            </div>
            <div className="servicesGrid">
              <div className="serviceCard">
                <div className="iconBox">
                  <svg
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.25 15.75L10 13.9688L7.28125 11.25L10 8.53125L8.25 6.75L3.75 11.25L8.25 15.75ZM14.25 15.75L18.75 11.25L14.25 6.75L12.5 8.53125L15.2188 11.25L12.5 13.9688L14.25 15.75ZM2.5 22.5C1.8125 22.5 1.22396 22.2552 0.734375 21.7656C0.244792 21.276 0 20.6875 0 20V2.5C0 1.8125 0.244792 1.22396 0.734375 0.734375C1.22396 0.244792 1.8125 0 2.5 0H20C20.6875 0 21.276 0.244792 21.7656 0.734375C22.2552 1.22396 22.5 1.8125 22.5 2.5V20C22.5 20.6875 22.2552 21.276 21.7656 21.7656C21.276 22.2552 20.6875 22.5 20 22.5H2.5ZM2.5 20H20V2.5H2.5V20ZM2.5 2.5V20V2.5Z"
                      fill="#1C1B1B"
                    />
                  </svg>
                </div>
                <h4>React.js Development</h4>
                <ul>
                  <li>SaaS dashboards</li>
                  <li>Enterprise web applications</li>
                  <li>Custom React component libraries</li>
                  <li>Scalable frontend architectures</li>
                  <li>Interactive user interfaces</li>
                </ul>
              </div>
              <div className="serviceCard">
                <div className="iconBox">
                  <svg
                    width="25"
                    height="20"
                    viewBox="0 0 25 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5625 14.375C11.0625 14.875 11.7083 15.1198 12.5 15.1094C13.2917 15.099 13.875 14.8125 14.25 14.25L21.25 3.75L10.75 10.75C10.1875 11.125 9.89062 11.6979 9.85938 12.4688C9.82812 13.2396 10.0625 13.875 10.5625 14.375ZM12.5 0C13.7292 0 14.9115 0.171875 16.0469 0.515625C17.1823 0.859375 18.25 1.375 19.25 2.0625L16.875 3.5625C16.1875 3.20833 15.474 2.94271 14.7344 2.76562C13.9948 2.58854 13.25 2.5 12.5 2.5C9.72917 2.5 7.36979 3.47396 5.42188 5.42188C3.47396 7.36979 2.5 9.72917 2.5 12.5C2.5 13.375 2.61979 14.2396 2.85938 15.0938C3.09896 15.9479 3.4375 16.75 3.875 17.5H21.125C21.6042 16.7083 21.9531 15.8854 22.1719 15.0312C22.3906 14.1771 22.5 13.2917 22.5 12.375C22.5 11.625 22.4115 10.8958 22.2344 10.1875C22.0573 9.47917 21.7917 8.79167 21.4375 8.125L22.9375 5.75C23.5625 6.72917 24.0573 7.77083 24.4219 8.875C24.7865 9.97917 24.9792 11.125 25 12.3125C25.0208 13.5 24.8854 14.6354 24.5938 15.7188C24.3021 16.8021 23.875 17.8333 23.3125 18.8125C23.0833 19.1875 22.7708 19.4792 22.375 19.6875C21.9792 19.8958 21.5625 20 21.125 20H3.875C3.4375 20 3.02083 19.8958 2.625 19.6875C2.22917 19.4792 1.91667 19.1875 1.6875 18.8125C1.14583 17.875 0.729167 16.8802 0.4375 15.8281C0.145833 14.776 0 13.6667 0 12.5C0 10.7708 0.328125 9.15104 0.984375 7.64062C1.64062 6.13021 2.53646 4.80729 3.67188 3.67188C4.80729 2.53646 6.13542 1.64062 7.65625 0.984375C9.17708 0.328125 10.7917 0 12.5 0Z"
                      fill="#1C1B1B"
                    />
                  </svg>
                </div>
                <h4>Next.js Development</h4>
                <ul>
                  <li>Server-side rendered web applications</li>
                  <li>SEO-optimized websites</li>
                  <li>High-performance landing pages</li>
                  <li>Scalable frontend systems</li>
                </ul>
              </div>
              <div className="serviceCard">
                <div className="iconBox">
                  <svg
                    width="14"
                    height="23"
                    viewBox="0 0 14 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.3125 22.5L0 19.75L3.5625 9.9375C3.875 10.2292 4.21354 10.474 4.57812 10.6719C4.94271 10.8698 5.33333 11.0208 5.75 11.125L2.3125 20.5625L0.3125 22.5ZM13.4375 22.5L11.4375 20.5625L8 11.125C8.41667 11.0208 8.80729 10.8698 9.17188 10.6719C9.53646 10.474 9.875 10.2292 10.1875 9.9375L13.75 19.75L13.4375 22.5ZM6.875 10C5.83333 10 4.94792 9.63542 4.21875 8.90625C3.48958 8.17708 3.125 7.29167 3.125 6.25C3.125 5.4375 3.35938 4.71354 3.82812 4.07812C4.29688 3.44271 4.89583 3 5.625 2.75V0H8.125V2.75C8.85417 3 9.45312 3.44271 9.92188 4.07812C10.3906 4.71354 10.625 5.4375 10.625 6.25C10.625 7.29167 10.2604 8.17708 9.53125 8.90625C8.80208 9.63542 7.91667 10 6.875 10ZM6.875 7.5C7.22917 7.5 7.52604 7.38021 7.76562 7.14062C8.00521 6.90104 8.125 6.60417 8.125 6.25C8.125 5.89583 8.00521 5.59896 7.76562 5.35938C7.52604 5.11979 7.22917 5 6.875 5C6.52083 5 6.22396 5.11979 5.98438 5.35938C5.74479 5.59896 5.625 5.89583 5.625 6.25C5.625 6.60417 5.74479 6.90104 5.98438 7.14062C6.22396 7.38021 6.52083 7.5 6.875 7.5Z"
                      fill="#1C1B1B"
                    />
                  </svg>
                </div>
                <h4>Custom Frontend</h4>
                <ul>
                  <li> HTML5 & CSS3 development</li>
                  <li>JavaScript ES6 applications</li>
                  <li>TypeScript development</li>
                  <li>Responsive web design</li>
                  <li>Cross-browser compatibility</li>
                </ul>
              </div>
              <div className="serviceCard">
                <div className="iconBox">
                  <svg
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.5 7.5V0H22.5V7.5H12.5ZM0 12.5V0H10V12.5H0ZM12.5 22.5V10H22.5V22.5H12.5ZM0 22.5V15H10V22.5H0ZM2.5 10H7.5V2.5H2.5V10ZM15 20H20V12.5H15V20ZM15 5H20V2.5H15V5ZM2.5 20H7.5V17.5H2.5V20Z"
                      fill="#1C1B1B"
                    />
                  </svg>
                </div>
                <h4>SaaS Development</h4>
                <ul>
                  <li>SaaS dashboards</li>
                  <li> Admin panels</li>
                  <li>Analytics platforms</li>
                  <li>Data visualization interfaces</li>
                  <li>Scalable UI systems</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="hireDev-techStack">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-12">
                    <h2>Our Technology Stack</h2>
                    <p className="subText">
                      Modern tools for ambitious projects
                    </p>
                    <ul className="techRow">
                      {[
                        "HTML5",
                        "CSS3",
                        "JavaScript",
                        "TypeScript",
                        "React",
                        "AngularJS",
                        "Next.js",
                        "Node.js",
                        "React Native",
                        "Tailwind",
                        "Redux",
                        "Bootstrap",
                        "Material UI",
                      ].map((t) => (
                        <li key={t} className="techPill">
                          {t}
                        </li>
                      ))}
                    </ul>
                    <p className="btmTxtText">
                      Our developers use modern development practices to ensure
                      <strong>
                        {" "}
                        high performance, scalability, and maintainability
                      </strong>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="hireDev-whyChoose">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Why US Companies Work with Hummingtec? </h2>
                <div className="whyGrid">
                  <div className="whyCard">
                    <div className="iconBox">
                      <svg
                        width="20"
                        height="25"
                        viewBox="0 0 20 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.6875 16.9375L15.75 9.875L13.9688 8.09375L8.6875 13.375L6.0625 10.75L4.28125 12.5312L8.6875 16.9375ZM10 25C7.10417 24.2708 4.71354 22.6094 2.82812 20.0156C0.942708 17.4219 0 14.5417 0 11.375V3.75L10 0L20 3.75V11.375C20 14.5417 19.0573 17.4219 17.1719 20.0156C15.2865 22.6094 12.8958 24.2708 10 25ZM10 22.375C12.1667 21.6875 13.9583 20.3125 15.375 18.25C16.7917 16.1875 17.5 13.8958 17.5 11.375V5.46875L10 2.65625L2.5 5.46875V11.375C2.5 13.8958 3.20833 16.1875 4.625 18.25C6.04167 20.3125 7.83333 21.6875 10 22.375Z"
                          fill="#451464"
                        />
                      </svg>
                    </div>
                    <h4>Experienced Frontend Engineers</h4>
                    <p>
                      Our developers have experience building modern web
                      applications for startups, SaaS platforms, and digital
                      products.
                    </p>
                  </div>
                  <div className="whyCard">
                    <div className="iconBox">
                      <svg
                        width="28"
                        height="20"
                        viewBox="0 0 28 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.25 11.25C15.2083 11.25 14.3229 10.8854 13.5938 10.1562C12.8646 9.42708 12.5 8.54167 12.5 7.5C12.5 6.45833 12.8646 5.57292 13.5938 4.84375C14.3229 4.11458 15.2083 3.75 16.25 3.75C17.2917 3.75 18.1771 4.11458 18.9062 4.84375C19.6354 5.57292 20 6.45833 20 7.5C20 8.54167 19.6354 9.42708 18.9062 10.1562C18.1771 10.8854 17.2917 11.25 16.25 11.25ZM7.5 15C6.8125 15 6.22396 14.7552 5.73438 14.2656C5.24479 13.776 5 13.1875 5 12.5V2.5C5 1.8125 5.24479 1.22396 5.73438 0.734375C6.22396 0.244792 6.8125 0 7.5 0H25C25.6875 0 26.276 0.244792 26.7656 0.734375C27.2552 1.22396 27.5 1.8125 27.5 2.5V12.5C27.5 13.1875 27.2552 13.776 26.7656 14.2656C26.276 14.7552 25.6875 15 25 15H7.5ZM10 12.5H22.5C22.5 11.8125 22.7448 11.224 23.2344 10.7344C23.724 10.2448 24.3125 10 25 10V5C24.3125 5 23.724 4.75521 23.2344 4.26562C22.7448 3.77604 22.5 3.1875 22.5 2.5H10C10 3.1875 9.75521 3.77604 9.26562 4.26562C8.77604 4.75521 8.1875 5 7.5 5V10C8.1875 10 8.77604 10.2448 9.26562 10.7344C9.75521 11.224 10 11.8125 10 12.5ZM23.75 20H2.5C1.8125 20 1.22396 19.7552 0.734375 19.2656C0.244792 18.776 0 18.1875 0 17.5V3.75H2.5V17.5H23.75V20ZM7.5 12.5V2.5V12.5Z"
                          fill="#451464"
                        />
                      </svg>
                    </div>
                    <h4>Cost-Efficient Development</h4>
                    <p>
                      Hiring in-house developers in the US can be expensive. Our
                      remote development team provides high-quality engineering
                      at competitive pricing.
                    </p>
                  </div>
                  <div className="whyCard">
                    <div className="iconBox">
                      <svg
                        width="20"
                        height="25"
                        viewBox="0 0 20 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 25C7.10417 24.2708 4.71354 22.6094 2.82812 20.0156C0.942708 17.4219 0 14.5417 0 11.375V3.75L10 0L20 3.75V11.375C20 14.5417 19.0573 17.4219 17.1719 20.0156C15.2865 22.6094 12.8958 24.2708 10 25ZM10 22.375C12.1667 21.6875 13.9583 20.3125 15.375 18.25C16.7917 16.1875 17.5 13.8958 17.5 11.375V5.46875L10 2.65625L2.5 5.46875V11.375C2.5 13.8958 3.20833 16.1875 4.625 18.25C6.04167 20.3125 7.83333 21.6875 10 22.375ZM7.5 17.5H12.5C12.8542 17.5 13.151 17.3802 13.3906 17.1406C13.6302 16.901 13.75 16.6042 13.75 16.25V12.5C13.75 12.1458 13.6302 11.849 13.3906 11.6094C13.151 11.3698 12.8542 11.25 12.5 11.25V10C12.5 9.3125 12.2552 8.72396 11.7656 8.23438C11.276 7.74479 10.6875 7.5 10 7.5C9.3125 7.5 8.72396 7.74479 8.23438 8.23438C7.74479 8.72396 7.5 9.3125 7.5 10V11.25C7.14583 11.25 6.84896 11.3698 6.60938 11.6094C6.36979 11.849 6.25 12.1458 6.25 12.5V16.25C6.25 16.6042 6.36979 16.901 6.60938 17.1406C6.84896 17.3802 7.14583 17.5 7.5 17.5ZM8.75 11.25V10C8.75 9.64583 8.86979 9.34896 9.10938 9.10938C9.34896 8.86979 9.64583 8.75 10 8.75C10.3542 8.75 10.651 8.86979 10.8906 9.10938C11.1302 9.34896 11.25 9.64583 11.25 10V11.25H8.75Z"
                          fill="#451464"
                        />
                      </svg>
                    </div>
                    <h4>Security & Data Protection</h4>
                    <p>
                      We work using secure development environments including
                      VPN access and remote systems, ensuring full compliance
                      with client data security and intellectual property
                      policies.
                    </p>
                  </div>
                  <div className="whyCard">
                    <div className="iconBox">
                      <svg
                        width="28"
                        height="25"
                        viewBox="0 0 28 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.6062 22.5C13.6896 22.5 13.7729 22.4792 13.8562 22.4375C13.9396 22.3958 14.0021 22.3542 14.0437 22.3125L24.2938 12.0625C24.5438 11.8125 24.726 11.5312 24.8406 11.2188C24.9552 10.9062 25.0125 10.5938 25.0125 10.2812C25.0125 9.94792 24.9552 9.63021 24.8406 9.32812C24.726 9.02604 24.5438 8.76042 24.2938 8.53125L18.9813 3.21875C18.7521 2.96875 18.4865 2.78646 18.1844 2.67188C17.8823 2.55729 17.5646 2.5 17.2313 2.5C16.9188 2.5 16.6063 2.55729 16.2938 2.67188C15.9813 2.78646 15.7 2.96875 15.45 3.21875L15.1062 3.5625L17.4188 5.90625C17.7313 6.19792 17.9604 6.53125 18.1063 6.90625C18.2521 7.28125 18.325 7.67708 18.325 8.09375C18.325 8.96875 18.0281 9.70312 17.4344 10.2969C16.8406 10.8906 16.1063 11.1875 15.2312 11.1875C14.8146 11.1875 14.4135 11.1146 14.0281 10.9688C13.6427 10.8229 13.3042 10.6042 13.0125 10.3125L10.6687 8L5.2 13.4688C5.1375 13.5312 5.09062 13.599 5.05937 13.6719C5.02812 13.7448 5.0125 13.8229 5.0125 13.9062C5.0125 14.0729 5.075 14.224 5.2 14.3594C5.325 14.4948 5.47083 14.5625 5.6375 14.5625C5.72083 14.5625 5.80417 14.5417 5.8875 14.5C5.97083 14.4583 6.03333 14.4167 6.075 14.375L10.325 10.125L12.075 11.875L7.85625 16.125C7.79375 16.1875 7.74687 16.2552 7.71562 16.3281C7.68437 16.401 7.66875 16.4792 7.66875 16.5625C7.66875 16.7292 7.73125 16.875 7.85625 17C7.98125 17.125 8.12708 17.1875 8.29375 17.1875C8.37708 17.1875 8.46042 17.1667 8.54375 17.125C8.62708 17.0833 8.68958 17.0417 8.73125 17L12.9812 12.7812L14.7312 14.5312L10.5125 18.7812C10.45 18.8229 10.4031 18.8854 10.3719 18.9688C10.3406 19.0521 10.325 19.1354 10.325 19.2188C10.325 19.3854 10.3875 19.5312 10.5125 19.6562C10.6375 19.7812 10.7833 19.8438 10.95 19.8438C11.0333 19.8438 11.1115 19.8281 11.1844 19.7969C11.2573 19.7656 11.325 19.7188 11.3875 19.6562L15.6375 15.4375L17.3875 17.1875L13.1375 21.4375C13.075 21.5 13.0281 21.5677 12.9969 21.6406C12.9656 21.7135 12.95 21.7917 12.95 21.875C12.95 22.0417 13.0177 22.1875 13.1531 22.3125C13.2885 22.4375 13.4396 22.5 13.6062 22.5ZM13.575 25C12.8042 25 12.1219 24.7448 11.5281 24.2344C10.9344 23.724 10.5854 23.0833 10.4812 22.3125C9.77292 22.2083 9.17917 21.9167 8.7 21.4375C8.22083 20.9583 7.92917 20.3646 7.825 19.6562C7.11667 19.5521 6.52812 19.2552 6.05937 18.7656C5.59062 18.276 5.30417 17.6875 5.2 17C4.40833 16.8958 3.7625 16.5521 3.2625 15.9688C2.7625 15.3854 2.5125 14.6979 2.5125 13.9062C2.5125 13.4896 2.59063 13.0885 2.74688 12.7031C2.90313 12.3177 3.12708 11.9792 3.41875 11.6875L10.6687 4.46875L14.7625 8.5625C14.8042 8.625 14.8667 8.67188 14.95 8.70312C15.0333 8.73438 15.1167 8.75 15.2 8.75C15.3875 8.75 15.5437 8.69271 15.6687 8.57812C15.7937 8.46354 15.8562 8.3125 15.8562 8.125C15.8562 8.04167 15.8406 7.95833 15.8094 7.875C15.7781 7.79167 15.7312 7.72917 15.6687 7.6875L11.2 3.21875C10.9708 2.96875 10.7052 2.78646 10.4031 2.67188C10.101 2.55729 9.78333 2.5 9.45 2.5C9.1375 2.5 8.825 2.55729 8.5125 2.67188C8.2 2.78646 7.91875 2.96875 7.66875 3.21875L3.2625 7.65625C3.075 7.84375 2.91875 8.0625 2.79375 8.3125C2.66875 8.5625 2.58542 8.8125 2.54375 9.0625C2.50208 9.3125 2.50208 9.56771 2.54375 9.82812C2.58542 10.0885 2.66875 10.3333 2.79375 10.5625L0.98125 12.375C0.627083 11.8958 0.366667 11.3698 0.2 10.7969C0.0333333 10.224 -0.0291667 9.64583 0.0125 9.0625C0.0541667 8.47917 0.2 7.91146 0.45 7.35938C0.7 6.80729 1.04375 6.3125 1.48125 5.875L5.8875 1.46875C6.3875 0.989583 6.94479 0.625 7.55937 0.375C8.17396 0.125 8.80417 0 9.45 0C10.0958 0 10.726 0.125 11.3406 0.375C11.9552 0.625 12.5021 0.989583 12.9812 1.46875L13.325 1.8125L13.6687 1.46875C14.1687 0.989583 14.726 0.625 15.3406 0.375C15.9552 0.125 16.5854 0 17.2313 0C17.8771 0 18.5073 0.125 19.1219 0.375C19.7365 0.625 20.2833 0.989583 20.7625 1.46875L26.0438 6.75C26.5229 7.22917 26.8875 7.78125 27.1375 8.40625C27.3875 9.03125 27.5125 9.66667 27.5125 10.3125C27.5125 10.9583 27.3875 11.5885 27.1375 12.2031C26.8875 12.8177 26.5229 13.3646 26.0438 13.8438L15.7937 24.0625C15.5021 24.3542 15.1635 24.5833 14.7781 24.75C14.3927 24.9167 13.9917 25 13.575 25Z"
                          fill="#451464"
                        />
                      </svg>
                    </div>
                    <h4>Dependable Development Partner</h4>
                    <p>
                      We prioritize long-term relationships and ensure projects
                      are delivered successfully without leaving clients midway.
                    </p>
                  </div>
                  <div className="whyCard">
                    <div className="iconBox">
                      <svg
                        width="28"
                        height="19"
                        viewBox="0 0 28 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.75 15C15.3125 15 16.6406 14.4531 17.7344 13.3594C18.8281 12.2656 19.375 10.9375 19.375 9.375C19.375 7.8125 18.8281 6.48438 17.7344 5.39062C16.6406 4.29688 15.3125 3.75 13.75 3.75C12.1875 3.75 10.8594 4.29688 9.76562 5.39062C8.67188 6.48438 8.125 7.8125 8.125 9.375C8.125 10.9375 8.67188 12.2656 9.76562 13.3594C10.8594 14.4531 12.1875 15 13.75 15ZM13.75 12.75C12.8125 12.75 12.0156 12.4219 11.3594 11.7656C10.7031 11.1094 10.375 10.3125 10.375 9.375C10.375 8.4375 10.7031 7.64062 11.3594 6.98438C12.0156 6.32812 12.8125 6 13.75 6C14.6875 6 15.4844 6.32812 16.1406 6.98438C16.7969 7.64062 17.125 8.4375 17.125 9.375C17.125 10.3125 16.7969 11.1094 16.1406 11.7656C15.4844 12.4219 14.6875 12.75 13.75 12.75ZM13.75 18.75C10.7083 18.75 7.9375 17.901 5.4375 16.2031C2.9375 14.5052 1.125 12.2292 0 9.375C1.125 6.52083 2.9375 4.24479 5.4375 2.54688C7.9375 0.848958 10.7083 0 13.75 0C16.7917 0 19.5625 0.848958 22.0625 2.54688C24.5625 4.24479 26.375 6.52083 27.5 9.375C26.375 12.2292 24.5625 14.5052 22.0625 16.2031C19.5625 17.901 16.7917 18.75 13.75 18.75ZM13.75 16.25C16.1042 16.25 18.2656 15.6302 20.2344 14.3906C22.2031 13.151 23.7083 11.4792 24.75 9.375C23.7083 7.27083 22.2031 5.59896 20.2344 4.35938C18.2656 3.11979 16.1042 2.5 13.75 2.5C11.3958 2.5 9.23438 3.11979 7.26562 4.35938C5.29688 5.59896 3.79167 7.27083 2.75 9.375C3.79167 11.4792 5.29688 13.151 7.26562 14.3906C9.23438 15.6302 11.3958 16.25 13.75 16.25Z"
                          fill="#451464"
                        />
                      </svg>
                    </div>
                    <h4>Transparent Pricing</h4>
                    <p>
                      No hidden costs. No unexpected charges. We maintain
                      complete pricing transparency from project start to
                      completion.
                    </p>
                  </div>
                  <div className="whyCard">
                    <div className="iconBox">
                      <svg
                        width="30"
                        height="29"
                        viewBox="0 0 30 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.5 28.75C6.45833 28.75 5.57292 28.3854 4.84375 27.6562C4.11458 26.9271 3.75 26.0417 3.75 25C3.75 23.9583 4.11458 23.0729 4.84375 22.3438C5.57292 21.6146 6.45833 21.25 7.5 21.25C7.79167 21.25 8.0625 21.2812 8.3125 21.3438C8.5625 21.4062 8.80208 21.4896 9.03125 21.5938L10.8125 19.375C10.2292 18.7292 9.82292 18 9.59375 17.1875C9.36458 16.375 9.3125 15.5625 9.4375 14.75L6.90625 13.9062C6.55208 14.4271 6.10417 14.8438 5.5625 15.1562C5.02083 15.4688 4.41667 15.625 3.75 15.625C2.70833 15.625 1.82292 15.2604 1.09375 14.5312C0.364583 13.8021 0 12.9167 0 11.875C0 10.8333 0.364583 9.94792 1.09375 9.21875C1.82292 8.48958 2.70833 8.125 3.75 8.125C4.79167 8.125 5.67708 8.48958 6.40625 9.21875C7.13542 9.94792 7.5 10.8333 7.5 11.875C7.5 11.9167 7.5 11.9583 7.5 12C7.5 12.0417 7.5 12.0833 7.5 12.125L10.0312 13C10.4479 12.25 11.0052 11.6146 11.7031 11.0938C12.401 10.5729 13.1875 10.2396 14.0625 10.0938V7.375C13.25 7.14583 12.5781 6.70312 12.0469 6.04688C11.5156 5.39062 11.25 4.625 11.25 3.75C11.25 2.70833 11.6146 1.82292 12.3438 1.09375C13.0729 0.364583 13.9583 0 15 0C16.0417 0 16.9271 0.364583 17.6562 1.09375C18.3854 1.82292 18.75 2.70833 18.75 3.75C18.75 4.625 18.4792 5.39062 17.9375 6.04688C17.3958 6.70312 16.7292 7.14583 15.9375 7.375V10.0938C16.8125 10.2396 17.599 10.5729 18.2969 11.0938C18.9948 11.6146 19.5521 12.25 19.9688 13L22.5 12.125C22.5 12.0833 22.5 12.0417 22.5 12C22.5 11.9583 22.5 11.9167 22.5 11.875C22.5 10.8333 22.8646 9.94792 23.5938 9.21875C24.3229 8.48958 25.2083 8.125 26.25 8.125C27.2917 8.125 28.1771 8.48958 28.9062 9.21875C29.6354 9.94792 30 10.8333 30 11.875C30 12.9167 29.6354 13.8021 28.9062 14.5312C28.1771 15.2604 27.2917 15.625 26.25 15.625C25.5833 15.625 24.974 15.4688 24.4219 15.1562C23.8698 14.8438 23.4271 14.4271 23.0938 13.9062L20.5625 14.75C20.6875 15.5625 20.6354 16.3698 20.4062 17.1719C20.1771 17.974 19.7708 18.7083 19.1875 19.375L20.9688 21.5625C21.1979 21.4583 21.4375 21.3802 21.6875 21.3281C21.9375 21.276 22.2083 21.25 22.5 21.25C23.5417 21.25 24.4271 21.6146 25.1562 22.3438C25.8854 23.0729 26.25 23.9583 26.25 25C26.25 26.0417 25.8854 26.9271 25.1562 27.6562C24.4271 28.3854 23.5417 28.75 22.5 28.75C21.4583 28.75 20.5729 28.3854 19.8438 27.6562C19.1146 26.9271 18.75 26.0417 18.75 25C18.75 24.5833 18.8177 24.1823 18.9531 23.7969C19.0885 23.4115 19.2708 23.0625 19.5 22.75L17.7188 20.5312C16.8646 21.0104 15.9531 21.25 14.9844 21.25C14.0156 21.25 13.1042 21.0104 12.25 20.5312L10.5 22.75C10.7292 23.0625 10.9115 23.4115 11.0469 23.7969C11.1823 24.1823 11.25 24.5833 11.25 25C11.25 26.0417 10.8854 26.9271 10.1562 27.6562C9.42708 28.3854 8.54167 28.75 7.5 28.75ZM3.75 13.125C4.10417 13.125 4.40104 13.0052 4.64062 12.7656C4.88021 12.526 5 12.2292 5 11.875C5 11.5208 4.88021 11.224 4.64062 10.9844C4.40104 10.7448 4.10417 10.625 3.75 10.625C3.39583 10.625 3.09896 10.7448 2.85938 10.9844C2.61979 11.224 2.5 11.5208 2.5 11.875C2.5 12.2292 2.61979 12.526 2.85938 12.7656C3.09896 13.0052 3.39583 13.125 3.75 13.125ZM7.5 26.25C7.85417 26.25 8.15104 26.1302 8.39062 25.8906C8.63021 25.651 8.75 25.3542 8.75 25C8.75 24.6458 8.63021 24.349 8.39062 24.1094C8.15104 23.8698 7.85417 23.75 7.5 23.75C7.14583 23.75 6.84896 23.8698 6.60938 24.1094C6.36979 24.349 6.25 24.6458 6.25 25C6.25 25.3542 6.36979 25.651 6.60938 25.8906C6.84896 26.1302 7.14583 26.25 7.5 26.25ZM15 5C15.3542 5 15.651 4.88021 15.8906 4.64062C16.1302 4.40104 16.25 4.10417 16.25 3.75C16.25 3.39583 16.1302 3.09896 15.8906 2.85938C15.651 2.61979 15.3542 2.5 15 2.5C14.6458 2.5 14.349 2.61979 14.1094 2.85938C13.8698 3.09896 13.75 3.39583 13.75 3.75C13.75 4.10417 13.8698 4.40104 14.1094 4.64062C14.349 4.88021 14.6458 5 15 5ZM15 18.75C15.875 18.75 16.6146 18.4479 17.2188 17.8438C17.8229 17.2396 18.125 16.5 18.125 15.625C18.125 14.75 17.8229 14.0104 17.2188 13.4062C16.6146 12.8021 15.875 12.5 15 12.5C14.125 12.5 13.3854 12.8021 12.7812 13.4062C12.1771 14.0104 11.875 14.75 11.875 15.625C11.875 16.5 12.1771 17.2396 12.7812 17.8438C13.3854 18.4479 14.125 18.75 15 18.75ZM22.5 26.25C22.8542 26.25 23.151 26.1302 23.3906 25.8906C23.6302 25.651 23.75 25.3542 23.75 25C23.75 24.6458 23.6302 24.349 23.3906 24.1094C23.151 23.8698 22.8542 23.75 22.5 23.75C22.1458 23.75 21.849 23.8698 21.6094 24.1094C21.3698 24.349 21.25 24.6458 21.25 25C21.25 25.3542 21.3698 25.651 21.6094 25.8906C21.849 26.1302 22.1458 26.25 22.5 26.25ZM26.25 13.125C26.6042 13.125 26.901 13.0052 27.1406 12.7656C27.3802 12.526 27.5 12.2292 27.5 11.875C27.5 11.5208 27.3802 11.224 27.1406 10.9844C26.901 10.7448 26.6042 10.625 26.25 10.625C25.8958 10.625 25.599 10.7448 25.3594 10.9844C25.1198 11.224 25 11.5208 25 11.875C25 12.2292 25.1198 12.526 25.3594 12.7656C25.599 13.0052 25.8958 13.125 26.25 13.125Z"
                          fill="#451464"
                        />
                      </svg>
                    </div>
                    <h4>Seamless Collaboration</h4>
                    <p>
                      Our developers work closely with your team using modern
                      collaboration tools such as Slack, Jira, GitHub, and
                      project management platforms.
                    </p>
                  </div>
                  <div className="whyCard">
                    <div className="iconBox">
                      <svg
                        width="23"
                        height="23"
                        viewBox="0 0 23 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.25 22.5C9.6875 22.5 8.22396 22.2031 6.85938 21.6094C5.49479 21.0156 4.30729 20.2135 3.29688 19.2031C2.28646 18.1927 1.48438 17.0052 0.890625 15.6406C0.296875 14.276 0 12.8125 0 11.25C0 9.6875 0.296875 8.22396 0.890625 6.85938C1.48438 5.49479 2.28646 4.30729 3.29688 3.29688C4.30729 2.28646 5.49479 1.48438 6.85938 0.890625C8.22396 0.296875 9.6875 0 11.25 0C12.9583 0 14.5781 0.364583 16.1094 1.09375C17.6406 1.82292 18.9375 2.85417 20 4.1875V1.25H22.5V8.75H15V6.25H18.4375C17.5833 5.08333 16.5312 4.16667 15.2812 3.5C14.0312 2.83333 12.6875 2.5 11.25 2.5C8.8125 2.5 6.74479 3.34896 5.04688 5.04688C3.34896 6.74479 2.5 8.8125 2.5 11.25C2.5 13.6875 3.34896 15.7552 5.04688 17.4531C6.74479 19.151 8.8125 20 11.25 20C13.4375 20 15.349 19.2917 16.9844 17.875C18.6198 16.4583 19.5833 14.6667 19.875 12.5H22.4375C22.125 15.3542 20.901 17.7344 18.7656 19.6406C16.6302 21.5469 14.125 22.5 11.25 22.5ZM14.75 16.5L10 11.75V5H12.5V10.75L16.5 14.75L14.75 16.5Z"
                          fill="#451464"
                        />
                      </svg>
                    </div>
                    <h4>Agile Development Process</h4>
                    <p>
                      We follow agile development practices to ensure faster
                      delivery cycles and continuous product improvements.
                    </p>
                  </div>
                  <div className="whyCard">
                    <div className="iconBox">
                      <svg
                        width="25"
                        height="23"
                        viewBox="0 0 25 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 22.9375L10.6875 21.3125C8.58333 19.4167 6.84375 17.7812 5.46875 16.4062C4.09375 15.0312 3 13.7969 2.1875 12.7031C1.375 11.6094 0.807292 10.6042 0.484375 9.6875C0.161458 8.77083 0 7.83333 0 6.875C0 4.91667 0.65625 3.28125 1.96875 1.96875C3.28125 0.65625 4.91667 0 6.875 0C7.95833 0 8.98958 0.229167 9.96875 0.6875C10.9479 1.14583 11.7917 1.79167 12.5 2.625C13.2083 1.79167 14.0521 1.14583 15.0312 0.6875C16.0104 0.229167 17.0417 0 18.125 0C20.0833 0 21.7188 0.65625 23.0312 1.96875C24.3438 3.28125 25 4.91667 25 6.875C25 7.83333 24.8385 8.77083 24.5156 9.6875C24.1927 10.6042 23.625 11.6094 22.8125 12.7031C22 13.7969 20.9062 15.0312 19.5312 16.4062C18.1562 17.7812 16.4167 19.4167 14.3125 21.3125L12.5 22.9375ZM12.5 19.5625C14.5 17.7708 16.1458 16.2344 17.4375 14.9531C18.7292 13.6719 19.75 12.5573 20.5 11.6094C21.25 10.6615 21.7708 9.81771 22.0625 9.07812C22.3542 8.33854 22.5 7.60417 22.5 6.875C22.5 5.625 22.0833 4.58333 21.25 3.75C20.4167 2.91667 19.375 2.5 18.125 2.5C17.1458 2.5 16.2396 2.77604 15.4062 3.32812C14.5729 3.88021 14 4.58333 13.6875 5.4375H11.3125C11 4.58333 10.4271 3.88021 9.59375 3.32812C8.76042 2.77604 7.85417 2.5 6.875 2.5C5.625 2.5 4.58333 2.91667 3.75 3.75C2.91667 4.58333 2.5 5.625 2.5 6.875C2.5 7.60417 2.64583 8.33854 2.9375 9.07812C3.22917 9.81771 3.75 10.6615 4.5 11.6094C5.25 12.5573 6.27083 13.6719 7.5625 14.9531C8.85417 16.2344 10.5 17.7708 12.5 19.5625Z"
                          fill="#451464"
                        />
                      </svg>
                    </div>
                    <h4>Long-Term Technology Partner</h4>
                    <p>
                      Many companies work with Hummingtec as their long-term
                      frontend development partner.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="hireDev-verticals">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Expertise Across Verticals</h2>
                <div className="vertGrid">
                  {[
                    {
                      icon: (
                        <svg
                          width="28"
                          height="20"
                          viewBox="0 0 28 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.875 20C4.97917 20 3.35938 19.3438 2.01562 18.0312C0.671875 16.7188 0 15.1146 0 13.2188C0 11.5938 0.489583 10.1458 1.46875 8.875C2.44792 7.60417 3.72917 6.79167 5.3125 6.4375C5.83333 4.52083 6.875 2.96875 8.4375 1.78125C10 0.59375 11.7708 0 13.75 0C16.1875 0 18.2552 0.848958 19.9531 2.54688C21.651 4.24479 22.5 6.3125 22.5 8.75C23.9375 8.91667 25.1302 9.53646 26.0781 10.6094C27.026 11.6823 27.5 12.9375 27.5 14.375C27.5 15.9375 26.9531 17.2656 25.8594 18.3594C24.7656 19.4531 23.4375 20 21.875 20H6.875ZM6.875 17.5H21.875C22.75 17.5 23.4896 17.1979 24.0938 16.5938C24.6979 15.9896 25 15.25 25 14.375C25 13.5 24.6979 12.7604 24.0938 12.1562C23.4896 11.5521 22.75 11.25 21.875 11.25H20V8.75C20 7.02083 19.3906 5.54688 18.1719 4.32812C16.9531 3.10938 15.4792 2.5 13.75 2.5C12.0208 2.5 10.5469 3.10938 9.32812 4.32812C8.10938 5.54688 7.5 7.02083 7.5 8.75H6.875C5.66667 8.75 4.63542 9.17708 3.78125 10.0312C2.92708 10.8854 2.5 11.9167 2.5 13.125C2.5 14.3333 2.92708 15.3646 3.78125 16.2188C4.63542 17.0729 5.66667 17.5 6.875 17.5Z"
                            fill="#1C1B1B"
                          />
                        </svg>
                      ),
                      label: "SaaS",
                    },
                    {
                      icon: (
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 25C6.8125 25 6.22396 24.7552 5.73438 24.2656C5.24479 23.776 5 23.1875 5 22.5C5 21.8125 5.24479 21.224 5.73438 20.7344C6.22396 20.2448 6.8125 20 7.5 20C8.1875 20 8.77604 20.2448 9.26562 20.7344C9.75521 21.224 10 21.8125 10 22.5C10 23.1875 9.75521 23.776 9.26562 24.2656C8.77604 24.7552 8.1875 25 7.5 25ZM20 25C19.3125 25 18.724 24.7552 18.2344 24.2656C17.7448 23.776 17.5 23.1875 17.5 22.5C17.5 21.8125 17.7448 21.224 18.2344 20.7344C18.724 20.2448 19.3125 20 20 20C20.6875 20 21.276 20.2448 21.7656 20.7344C22.2552 21.224 22.5 21.8125 22.5 22.5C22.5 23.1875 22.2552 23.776 21.7656 24.2656C21.276 24.7552 20.6875 25 20 25ZM6.4375 5L9.4375 11.25H18.1875L21.625 5H6.4375ZM5.25 2.5H23.6875C24.1667 2.5 24.5312 2.71354 24.7812 3.14062C25.0312 3.56771 25.0417 4 24.8125 4.4375L20.375 12.4375C20.1458 12.8542 19.8385 13.1771 19.4531 13.4062C19.0677 13.6354 18.6458 13.75 18.1875 13.75H8.875L7.5 16.25H22.5V18.75H7.5C6.5625 18.75 5.85417 18.3385 5.375 17.5156C4.89583 16.6927 4.875 15.875 5.3125 15.0625L7 12L2.5 2.5H0V0H4.0625L5.25 2.5ZM9.4375 11.25H18.1875H9.4375Z"
                            fill="#1C1B1B"
                          />
                        </svg>
                      ),
                      label: "E-commerce",
                    },
                    {
                      icon: (
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.75 20V11.25H6.25V20H3.75ZM11.25 20V11.25H13.75V20H11.25ZM0 25V22.5H25V25H0ZM18.75 20V11.25H21.25V20H18.75ZM0 8.75V6.25L12.5 0L25 6.25V8.75H0ZM5.5625 6.25H12.5H19.4375H5.5625ZM5.5625 6.25H19.4375L12.5 2.8125L5.5625 6.25Z"
                            fill="#1C1B1B"
                          />
                        </svg>
                      ),
                      label: "Fintech",
                    },
                    {
                      icon: (
                        <svg
                          width="20"
                          height="25"
                          viewBox="0 0 20 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.125 16.875H11.875V13.75H15V10H11.875V6.875H8.125V10H5V13.75H8.125V16.875ZM10 25C7.10417 24.2708 4.71354 22.6094 2.82812 20.0156C0.942708 17.4219 0 14.5417 0 11.375V3.75L10 0L20 3.75V11.375C20 14.5417 19.0573 17.4219 17.1719 20.0156C15.2865 22.6094 12.8958 24.2708 10 25ZM10 22.375C12.1667 21.6875 13.9583 20.3125 15.375 18.25C16.7917 16.1875 17.5 13.8958 17.5 11.375V5.46875L10 2.65625L2.5 5.46875V11.375C2.5 13.8958 3.20833 16.1875 4.625 18.25C6.04167 20.3125 7.83333 21.6875 10 22.375Z"
                            fill="#1C1B1B"
                          />
                        </svg>
                      ),
                      label: "HealthTech",
                    },
                    {
                      icon: (
                        <svg
                          width="28"
                          height="23"
                          viewBox="0 0 28 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.75 22.5L5 17.75V10.25L0 7.5L13.75 0L27.5 7.5V17.5H25V8.875L22.5 10.25V17.75L13.75 22.5ZM13.75 12.125L22.3125 7.5L13.75 2.875L5.1875 7.5L13.75 12.125ZM13.75 19.6562L20 16.2812V11.5625L13.75 15L7.5 11.5625V16.2812L13.75 19.6562Z"
                            fill="#1C1B1B"
                          />
                        </svg>
                      ),
                      label: "Digital Agencies",
                    },
                    {
                      icon: (
                        <svg
                          width="27"
                          height="27"
                          viewBox="0 0 27 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22.5 15.625V7.5L16.25 3.125L10 7.5V9.375H7.5V6.25L16.25 0L25 6.25V15.625H22.5ZM16.875 8.125H18.125V6.875H16.875V8.125ZM14.375 8.125H15.625V6.875H14.375V8.125ZM16.875 10.625H18.125V9.375H16.875V10.625ZM14.375 10.625H15.625V9.375H14.375V10.625ZM7.5 21.25L16.1875 23.625L23.625 21.3125C23.5208 21.125 23.3698 20.9635 23.1719 20.8281C22.974 20.6927 22.75 20.625 22.5 20.625H16.1875C15.625 20.625 15.1771 20.6042 14.8438 20.5625C14.5104 20.5208 14.1667 20.4375 13.8125 20.3125L10.9062 19.3438L11.5938 16.9062L14.125 17.75C14.4792 17.8542 14.8958 17.9375 15.375 18C15.8542 18.0625 16.5625 18.1042 17.5 18.125C17.5 17.8958 17.4323 17.6771 17.2969 17.4688C17.1615 17.2604 17 17.125 16.8125 17.0625L9.5 14.375H7.5V21.25ZM0 25.625V11.875H9.5C9.64583 11.875 9.79167 11.8906 9.9375 11.9219C10.0833 11.9531 10.2188 11.9896 10.3438 12.0312L17.6875 14.75C18.375 15 18.9323 15.4375 19.3594 16.0625C19.7865 16.6875 20 17.375 20 18.125H22.5C23.5417 18.125 24.4271 18.4688 25.1562 19.1562C25.8854 19.8438 26.25 20.75 26.25 21.875V23.125L16.25 26.25L7.5 23.8125V25.625H0ZM2.5 23.125H5V14.375H2.5V23.125Z"
                            fill="#1C1B1B"
                          />
                        </svg>
                      ),
                      label: "Real Estate",
                    },
                    {
                      icon: (
                        <svg
                          width="25"
                          height="20"
                          viewBox="0 0 25 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.5625 14.5625L19.6875 11.625C20 11.5417 20.2344 11.349 20.3906 11.0469C20.5469 10.7448 20.5833 10.4375 20.5 10.125C20.4167 9.8125 20.2344 9.57812 19.9531 9.42188C19.6719 9.26562 19.375 9.22917 19.0625 9.3125L16 10.125L11 5.4375L9.25 5.875L12.25 11.125L9.25 11.875L7.6875 10.6875L6.5 11L8.5625 14.5625ZM22.5 20H2.5C1.8125 20 1.22396 19.7552 0.734375 19.2656C0.244792 18.776 0 18.1875 0 17.5V12.5C0.6875 12.5 1.27604 12.2552 1.76562 11.7656C2.25521 11.276 2.5 10.6875 2.5 10C2.5 9.3125 2.25521 8.72396 1.76562 8.23438C1.27604 7.74479 0.6875 7.5 0 7.5V2.5C0 1.8125 0.244792 1.22396 0.734375 0.734375C1.22396 0.244792 1.8125 0 2.5 0H22.5C23.1875 0 23.776 0.244792 24.2656 0.734375C24.7552 1.22396 25 1.8125 25 2.5V17.5C25 18.1875 24.7552 18.776 24.2656 19.2656C23.776 19.7552 23.1875 20 22.5 20ZM22.5 17.5V2.5H2.5V5.6875C3.27083 6.14583 3.88021 6.75521 4.32812 7.51562C4.77604 8.27604 5 9.10417 5 10C5 10.8958 4.77604 11.724 4.32812 12.4844C3.88021 13.2448 3.27083 13.8542 2.5 14.3125V17.5H22.5Z"
                            fill="#1C1B1B"
                          />
                        </svg>
                      ),
                      label: "Travel",
                    },
                    {
                      icon: (
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.5 22.5C1.8125 22.5 1.22396 22.2552 0.734375 21.7656C0.244792 21.276 0 20.6875 0 20V2.5C0 1.8125 0.244792 1.22396 0.734375 0.734375C1.22396 0.244792 1.8125 0 2.5 0H13.75C14.4375 0 15.026 0.244792 15.5156 0.734375C16.0052 1.22396 16.25 1.8125 16.25 2.5V7.5625C15.8125 7.60417 15.3854 7.68229 14.9688 7.79688C14.5521 7.91146 14.1458 8.05208 13.75 8.21875V2.5H2.5V20H7.5V22.5H2.5ZM7.5 18.7188V17.5C7.5 17.2708 7.50521 17.0469 7.51562 16.8281C7.52604 16.6094 7.55208 16.3854 7.59375 16.1562C7.19792 16.0521 6.875 15.8333 6.625 15.5C6.375 15.1667 6.25 14.7917 6.25 14.375C6.25 13.8542 6.43229 13.4115 6.79688 13.0469C7.16146 12.6823 7.60417 12.5 8.125 12.5C8.22917 12.5 8.33333 12.5104 8.4375 12.5312C8.54167 12.5521 8.64583 12.5833 8.75 12.625C8.95833 12.25 9.19271 11.8906 9.45312 11.5469C9.71354 11.2031 9.98958 10.875 10.2812 10.5625C9.96875 10.375 9.63021 10.2344 9.26562 10.1406C8.90104 10.0469 8.52083 10 8.125 10C6.91667 10 5.88542 10.4271 5.03125 11.2812C4.17708 12.1354 3.75 13.1667 3.75 14.375C3.75 15.5 4.10938 16.4635 4.82812 17.2656C5.54688 18.0677 6.4375 18.5521 7.5 18.7188ZM8.125 8.125C8.64583 8.125 9.08854 7.94271 9.45312 7.57812C9.81771 7.21354 10 6.77083 10 6.25C10 5.72917 9.81771 5.28646 9.45312 4.92188C9.08854 4.55729 8.64583 4.375 8.125 4.375C7.60417 4.375 7.16146 4.55729 6.79688 4.92188C6.43229 5.28646 6.25 5.72917 6.25 6.25C6.25 6.77083 6.43229 7.21354 6.79688 7.57812C7.16146 7.94271 7.60417 8.125 8.125 8.125ZM15 25H12.5C11.8125 25 11.224 24.7552 10.7344 24.2656C10.2448 23.776 10 23.1875 10 22.5V17.5C10 15.4167 10.7292 13.6458 12.1875 12.1875C13.6458 10.7292 15.4167 10 17.5 10C19.5833 10 21.3542 10.7292 22.8125 12.1875C24.2708 13.6458 25 15.4167 25 17.5V22.5C25 23.1875 24.7552 23.776 24.2656 24.2656C23.776 24.7552 23.1875 25 22.5 25H20V18.75H23.125V17.5C23.125 15.9375 22.5781 14.6094 21.4844 13.5156C20.3906 12.4219 19.0625 11.875 17.5 11.875C15.9375 11.875 14.6094 12.4219 13.5156 13.5156C12.4219 14.6094 11.875 15.9375 11.875 17.5V18.75H15V25Z"
                            fill="#1C1B1B"
                          />
                        </svg>
                      ),
                      label: "Media",
                    },
                    {
                      icon: (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 10C8.625 10 7.44792 9.51042 6.46875 8.53125C5.48958 7.55208 5 6.375 5 5C5 3.625 5.48958 2.44792 6.46875 1.46875C7.44792 0.489583 8.625 0 10 0C11.375 0 12.5521 0.489583 13.5312 1.46875C14.5104 2.44792 15 3.625 15 5C15 6.375 14.5104 7.55208 13.5312 8.53125C12.5521 9.51042 11.375 10 10 10ZM0 20V16.5C0 15.7917 0.182292 15.1406 0.546875 14.5469C0.911458 13.9531 1.39583 13.5 2 13.1875C3.29167 12.5417 4.60417 12.0573 5.9375 11.7344C7.27083 11.4115 8.625 11.25 10 11.25C11.375 11.25 12.7292 11.4115 14.0625 11.7344C15.3958 12.0573 16.7083 12.5417 18 13.1875C18.6042 13.5 19.0885 13.9531 19.4531 14.5469C19.8177 15.1406 20 15.7917 20 16.5V20H0ZM2.5 17.5H17.5V16.5C17.5 16.2708 17.4427 16.0625 17.3281 15.875C17.2135 15.6875 17.0625 15.5417 16.875 15.4375C15.75 14.875 14.6146 14.4531 13.4688 14.1719C12.3229 13.8906 11.1667 13.75 10 13.75C8.83333 13.75 7.67708 13.8906 6.53125 14.1719C5.38542 14.4531 4.25 14.875 3.125 15.4375C2.9375 15.5417 2.78646 15.6875 2.67188 15.875C2.55729 16.0625 2.5 16.2708 2.5 16.5V17.5ZM10 7.5C10.6875 7.5 11.276 7.25521 11.7656 6.76562C12.2552 6.27604 12.5 5.6875 12.5 5C12.5 4.3125 12.2552 3.72396 11.7656 3.23438C11.276 2.74479 10.6875 2.5 10 2.5C9.3125 2.5 8.72396 2.74479 8.23438 3.23438C7.74479 3.72396 7.5 4.3125 7.5 5C7.5 5.6875 7.74479 6.27604 8.23438 6.76562C8.72396 7.25521 9.3125 7.5 10 7.5Z"
                            fill="#1C1B1B"
                          />
                        </svg>
                      ),
                      label: "Solopreneurs",
                    },
                  ].map((v) => (
                    <div key={v.label} className="vertCard">
                      <span className="vIcon">{v.icon}</span>
                      {v.label}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="staffOnBoardWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ttlWrap">
                  <h2>Our Development Process</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <ul>
                  <li>
                    <div className="itemWrap">
                      <div className="noWrap">
                        <h2>01</h2>
                      </div>
                      <div className="dataWrap">
                        <h2>Discovery & Planning</h2>
                        <p>
                          We begin by understanding your product vision,
                          business objectives, and technical requirements.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="noWrap">
                        <h2>02</h2>
                      </div>
                      <div className="dataWrap">
                        <h2>UI Architecture Design</h2>
                        <p>
                          Our team designs scalable frontend architecture
                          optimized for performance.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="noWrap">
                        <h2>03</h2>
                      </div>
                      <div className="dataWrap">
                        <h2>Development</h2>
                        <p>
                          Experienced developers build clean, efficient, and
                          maintainable code.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="noWrap">
                        <h2>04</h2>
                      </div>
                      <div className="dataWrap">
                        <h2>Testing & Optimization</h2>
                        <p>
                          We thoroughly test applications to ensure security,
                          performance, and reliability.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="noWrap">
                        <h2>05</h2>
                      </div>
                      <div className="dataWrap">
                        <h2>Launch & Ongoing Support</h2>
                        <p>
                          We help deploy your product and provide continuous
                          improvements and support.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <section className="hireDev-engagement">
          <div className="container">
            <h2>Flexible Engagement Models</h2>
            <p className="subText">
              Choose the model that best fits your project scale and complexity
            </p>
            <div className="engagGrid">
              <div className="engagCard">
                <h4>Dedicated Developers</h4>
                <p>
                  Best for stable client teams looking for frontend specialists
                  with long-term commitments.
                </p>
                <ul>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                        fill="#451464"
                      />
                    </svg>
                    Starts at $8/hr
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                        fill="#451464"
                      />
                    </svg>
                    Fully Integrated Team
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                        fill="#451464"
                      />
                    </svg>
                    Direct Communication
                  </li>
                </ul>
                <button
                  onClick={() => {
                    setFormData((prev) => ({ ...prev, type: "hire" }));
                    setLgShow(true);
                  }}
                  className="btnEngag"
                >
                  Enquire
                </button>
              </div>
              <div className="engagCard featured">
                <span className="badge">RECOMMENDED</span>
                <h4>Project-Based</h4>
                <p>
                  Tailored for product launches to execute specific feature
                  modules with clear milestones.
                </p>
                <ul>
                  <li>
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.03 15.33L16.4325 7.9275L14.9625 6.4575L9.03 12.39L6.0375 9.3975L4.5675 10.8675L9.03 15.33ZM10.5 21C9.0475 21 7.6825 20.7244 6.405 20.1731C5.1275 19.6219 4.01625 18.8737 3.07125 17.9287C2.12625 16.9838 1.37812 15.8725 0.826875 14.595C0.275625 13.3175 0 11.9525 0 10.5C0 9.0475 0.275625 7.6825 0.826875 6.405C1.37812 5.1275 2.12625 4.01625 3.07125 3.07125C4.01625 2.12625 5.1275 1.37812 6.405 0.826875C7.6825 0.275625 9.0475 0 10.5 0C11.9525 0 13.3175 0.275625 14.595 0.826875C15.8725 1.37812 16.9838 2.12625 17.9287 3.07125C18.8737 4.01625 19.6219 5.1275 20.1731 6.405C20.7244 7.6825 21 9.0475 21 10.5C21 11.9525 20.7244 13.3175 20.1731 14.595C19.6219 15.8725 18.8737 16.9838 17.9287 17.9287C16.9838 18.8737 15.8725 19.6219 14.595 20.1731C13.3175 20.7244 11.9525 21 10.5 21ZM10.5 18.9C12.845 18.9 14.8312 18.0862 16.4587 16.4587C18.0862 14.8312 18.9 12.845 18.9 10.5C18.9 8.155 18.0862 6.16875 16.4587 4.54125C14.8312 2.91375 12.845 2.1 10.5 2.1C8.155 2.1 6.16875 2.91375 4.54125 4.54125C2.91375 6.16875 2.1 8.155 2.1 10.5C2.1 12.845 2.91375 14.8312 4.54125 16.4587C6.16875 18.0862 8.155 18.9 10.5 18.9Z"
                        fill="white"
                      />
                    </svg>
                    Fixed Scope &amp; Price
                  </li>
                  <li>
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.03 15.33L16.4325 7.9275L14.9625 6.4575L9.03 12.39L6.0375 9.3975L4.5675 10.8675L9.03 15.33ZM10.5 21C9.0475 21 7.6825 20.7244 6.405 20.1731C5.1275 19.6219 4.01625 18.8737 3.07125 17.9287C2.12625 16.9838 1.37812 15.8725 0.826875 14.595C0.275625 13.3175 0 11.9525 0 10.5C0 9.0475 0.275625 7.6825 0.826875 6.405C1.37812 5.1275 2.12625 4.01625 3.07125 3.07125C4.01625 2.12625 5.1275 1.37812 6.405 0.826875C7.6825 0.275625 9.0475 0 10.5 0C11.9525 0 13.3175 0.275625 14.595 0.826875C15.8725 1.37812 16.9838 2.12625 17.9287 3.07125C18.8737 4.01625 19.6219 5.1275 20.1731 6.405C20.7244 7.6825 21 9.0475 21 10.5C21 11.9525 20.7244 13.3175 20.1731 14.595C19.6219 15.8725 18.8737 16.9838 17.9287 17.9287C16.9838 18.8737 15.8725 19.6219 14.595 20.1731C13.3175 20.7244 11.9525 21 10.5 21ZM10.5 18.9C12.845 18.9 14.8312 18.0862 16.4587 16.4587C18.0862 14.8312 18.9 12.845 18.9 10.5C18.9 8.155 18.0862 6.16875 16.4587 4.54125C14.8312 2.91375 12.845 2.1 10.5 2.1C8.155 2.1 6.16875 2.91375 4.54125 4.54125C2.91375 6.16875 2.1 8.155 2.1 10.5C2.1 12.845 2.91375 14.8312 4.54125 16.4587C6.16875 18.0862 8.155 18.9 10.5 18.9Z"
                        fill="white"
                      />
                    </svg>
                    Guaranteed Delivery
                  </li>
                  <li>
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.03 15.33L16.4325 7.9275L14.9625 6.4575L9.03 12.39L6.0375 9.3975L4.5675 10.8675L9.03 15.33ZM10.5 21C9.0475 21 7.6825 20.7244 6.405 20.1731C5.1275 19.6219 4.01625 18.8737 3.07125 17.9287C2.12625 16.9838 1.37812 15.8725 0.826875 14.595C0.275625 13.3175 0 11.9525 0 10.5C0 9.0475 0.275625 7.6825 0.826875 6.405C1.37812 5.1275 2.12625 4.01625 3.07125 3.07125C4.01625 2.12625 5.1275 1.37812 6.405 0.826875C7.6825 0.275625 9.0475 0 10.5 0C11.9525 0 13.3175 0.275625 14.595 0.826875C15.8725 1.37812 16.9838 2.12625 17.9287 3.07125C18.8737 4.01625 19.6219 5.1275 20.1731 6.405C20.7244 7.6825 21 9.0475 21 10.5C21 11.9525 20.7244 13.3175 20.1731 14.595C19.6219 15.8725 18.8737 16.9838 17.9287 17.9287C16.9838 18.8737 15.8725 19.6219 14.595 20.1731C13.3175 20.7244 11.9525 21 10.5 21ZM10.5 18.9C12.845 18.9 14.8312 18.0862 16.4587 16.4587C18.0862 14.8312 18.9 12.845 18.9 10.5C18.9 8.155 18.0862 6.16875 16.4587 4.54125C14.8312 2.91375 12.845 2.1 10.5 2.1C8.155 2.1 6.16875 2.91375 4.54125 4.54125C2.91375 6.16875 2.1 8.155 2.1 10.5C2.1 12.845 2.91375 14.8312 4.54125 16.4587C6.16875 18.0862 8.155 18.9 10.5 18.9Z"
                        fill="white"
                      />
                    </svg>
                    Milestone Payment
                  </li>
                </ul>
                <button
                  onClick={() => {
                    setFormData((prev) => ({ ...prev, type: "hire" }));
                    setLgShow(true);
                  }}
                  className="btnEngag"
                >
                  Enquire
                </button>
              </div>
              <div className="engagCard">
                <h4>Agency Partnerships</h4>
                <p>
                  Tailored for agencies needing a reliable backup dev team at
                  any scale, long-term.
                </p>
                <ul>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                        fill="#451464"
                      />
                    </svg>
                    White-label Systems
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                        fill="#451464"
                      />
                    </svg>
                    Revenue Sharing
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                        fill="#451464"
                      />
                    </svg>
                    Scalable Resources
                  </li>
                </ul>
                <button
                  onClick={() => {
                    setFormData((prev) => ({ ...prev, type: "partner" }));
                    setLgShow(true);
                  }}
                  className="btnEngag"
                >
                  Partner With Us
                </button>
              </div>
            </div>
          </div>
        </section>
        <div class="staffAugFaqWrap faQBGClr">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-8">
                <div class="ttlWrap">
                  <h2>Frequently Asked Questions</h2>
                </div>
                <div class="accordion" id="accordionExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        How can I hire developers from Hummingtec?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <p>
                          Simply contact our team and share your project
                          requirements. We will recommend the most suitable
                          engagement model for your project.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Do you work with US companies?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <p>
                          Yes. Hummingtec works with startups, SaaS companies,
                          and agencies across the{" "}
                          <strong>United States and globally.</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        What technologies do your developers specialize in?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <p>
                          Our developers specialize in{" "}
                          <strong>
                            React.js, Next.js, Angular, JavaScript, TypeScript,
                            and modern frontend frameworks.
                          </strong>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Can you support long-term development projects?
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <p>
                          Yes. Many clients partner with Hummingtec for
                          long-term development and ongoing product
                          improvements.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="hireDev-cta">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="innerBoxWrap">
                  <div className="row justify-content-center">
                    <div className="col-md-6">
                      <h2>Start Building with Hummingtec</h2>
                      <p>
                        Ready to scale your engineering team to launch a
                        world-class digital product? Let's discuss your roadmap
                        today.
                      </p>
                      <a href="/Contact" target="_blank" className="btnCta">
                        Contact Our Team
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Modal
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          className="contactUsPopup"
          centered
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <div className="titleWrap">
              <h2>Let’s Build Growth That Lasts</h2>
            </div>

            <form onSubmit={handleSubmit}>
              <ul className="formList">
                {/* Name */}
                <li>
                  <div className="inputField">
                    <input
                      type="text"
                      name="name"
                      placeholder="Name *"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </li>

                {/* Designation */}
                <li>
                  <div className="inputField">
                    <input
                      type="text"
                      name="designation"
                      placeholder="Designation *"
                      value={formData.designation}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </li>

                {/* Company */}
                <li>
                  <div className="inputField">
                    <input
                      type="text"
                      name="company"
                      placeholder="Company *"
                      value={formData.company}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </li>

                {/* Email */}
                <li>
                  <div className="inputField">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address *"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </li>

                {/* Project Description */}
                <li className="full">
                  <div className="inputField">
                    <textarea
                      name="projectDescription"
                      placeholder="Project Description *"
                      value={formData.projectDescription}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                </li>
              </ul>

              <div className="ctaWrap textCenter">
                <button type="submit" className="btnMarTop btnSubmti">
                  Submit
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
      <Footer></Footer>
    </>
  );
};
export default HireDevelopers;
